export const PrivacyPolicyBody = () => {
  return (
    <>
      <p>
        This Privacy Policy provides our privacy policy regarding the nature, purpose, use, and
        sharing of personal data (“Data”) collected from the users of the website gyro.finance and
        other websites which use subdomains of gyro.finance (the "Site"). This Privacy Policy also
        includes the Cookie Policy. We are committed to protecting and respecting your privacy.
        Please read this carefully as this Privacy Policy is legally binding when you use the Site.
        The purposes for the collection of Data are explained below.
      </p>
      <p>
        As used in this Privacy Policy, "we", "us" or "our" refers to FTL Labs, an exempted company
        incorporated and registered in the Cayman Islands. We will be a data controller pursuant to
        the Cayman Islands Data Protection Act, 2017 (as amended). You can reach us with any
        requests relating to this Privacy Policy via contact details provided below.
      </p>
      <h2>Data processing in connection with the Site</h2>
      <h3>Use of Cookies and Similar Technologies</h3>
      <p>
        The Site is using cookies. Cookies are small text files that are placed on your computer by
        websites that you visit. They are widely used in order to make websites work, or work more
        efficiently, as well as to provide information to the owners of the site. Cookies are
        typically stored on your computer's hard drive. Information collected from cookies is used
        by us to evaluate the effectiveness of our Site, analyze trends and enhance security. The
        information collected from cookies allows us to determine such things as which parts of the
        Site are most visited and difficulties our visitors may experience in accessing the Site.
        With this knowledge, we can improve the quality of your experience on the Site by
        recognizing and delivering more of the most desired features and information, as well as by
        resolving access difficulties.
      </p>
      <p>
        We use third party service providers, to assist us in better understanding the use of our
        Site. Our service providers will place cookies on the hard drive of your computer (or use
        similar technologies) and will receive information that we select that will educate us on
        such things as how visitors navigate around our Site. This information is aggregated to
        provide statistical data about our users' browsing actions and patterns, and does not
        personally identify individuals (however, see below information on Ethereum wallet
        addresses). This information may include:
      </p>
      <ul>
        <li>- Computer or mobile device information,</li>
        <li>
          - Website usage information, such as:
          <ul>
            <li> - Page views,</li>
            <li> - Account changes (i.e., connecting a wallet)</li>
            <li> - Button clicks</li>
            <li> - Input form changes</li>
            <li> - Errors.</li>
          </ul>
        </li>
      </ul>
      <p>
        Our service providers analyze this information and provide us with aggregate reports. The
        information and analysis provided by our service providers will be used to assist us in
        better understanding our visitors' interests in our Site and how to better serve those
        interests, as well as help ensure secure use of the website for all users. If you want to
        avoid using cookies altogether, you can disable cookies in your browser. However, disabling
        cookies might make it impossible for you to use certain features of the Site. Your use of
        the Site with a browser that is configured to accept cookies constitutes acceptance of our
        and third-party cookies.
      </p>
      <h3>Public Ethereum Addresses</h3>
      <p>
        We use and collect public Ethereum addresses to identify and document a user’s journey
        through our products and historical use of the Site. We may group and analyze these user
        journeys and historical usage collectively in order to improve our product user experience.
        We may also use this data to facilitate individual access to the Site and linked third party
        websites and in other ways related to individual use of the Site.
      </p>
      <p>
        The legal basis for this processing is our legitimate interests, such as monitoring and
        improving the Site, and the proper protection of the Site against risks.{" "}
      </p>
      <h3>Your Third-Party Accounts and Phone Number</h3>
      <p>
        We may ask for various pieces of personal information, for example your Twitter or GitHub
        account names or telephone number, in order to ensure secure use of the Site and prevent the
        risk of Sybil attacks. These categories of data will be used for this purpose only and
        stored only for the period of time necessary to fulfill this purpose. We will also not link
        Ethereum addresses with social media accounts in any lasting way. We may use external
        providers in order to process this data and verify its correctness for us.
      </p>
      <p>
        The legal basis for this processing is our legitimate interests, such as the proper
        protection of the Site against risks.
      </p>
      <h3>Blockchain Data</h3>
      <p>
        Note that we are not responsible for your use of the Ethereum blockchain and your data
        processed in this decentralized and permissionless network.
      </p>

      <h3>Your Inquiries</h3>
      <p>
        You may contact us by email to the following email address: legal@gyro.finance. We use the
        data that you provide in an email to us, which you may give voluntarily, only in order to
        answer your contact question or to reply to your email in the best possible manner.
      </p>
      <h2>Data retention period</h2>
      <p>
        We maintain Data exclusively within the time needed to follow relevant legal purposes. When
        we no longer need Data, you have withdrawn your consent or objected to our or our
        processors’ legitimate interests, we delete it unless the statutory requirements stipulate
        otherwise. Sometimes legal requirements may oblige us to retain certain data, for specific
        purposes, for an extended period of time. Reasons we might retain some data for longer
        periods of time include:
      </p>
      <ul>
        <li>- Security, fraud & abuse prevention;</li>
        <li>- Financial monitoring and record-keeping;</li>
        <li>- Complying with legal or regulatory requirements;</li>
        <li>- Ensuring the continuity of your interaction with the Site.</li>
      </ul>
      <h2>Your rights </h2>
      <h3>Right to access</h3>
      <p>
        As a data subject you have the right to obtain from us free information about your personal
        data processed at any time and a copy of this information. Furthermore, you will have access
        to the following information: the purposes of the processing; the categories of personal
        data concerned; where possible, the envisaged period for which the personal data will be
        processed, or, if not possible, the criteria used to determine that period; the existence of
        the right to request from us rectification or erasure of personal data, or restriction of
        processing of personal data concerning you, or to object to such processing; the existence
        of the right to lodge a complaint with a supervisory authority; where the personal data are
        not collected directly from you, any available information as to their source; and the
        existence of automated decision-making, including profiling, and, at least in those cases,
        meaningful information about the logic involved, as well as the significance and envisaged
        consequences of such processing for you.
      </p>
      <h3>Right to rectification</h3>
      <p>
        You have the right to obtain from us, without undue delay, the rectification of inaccurate
        personal data concerning you. Considering the purposes of the processing, you shall have the
        right to have incomplete personal data completed, including by means of providing a
        supplementary statement.
      </p>
      <h3>Right to be forgotten</h3>
      <p>
        You have the right to obtain from us the erasure of personal data concerning you as soon as
        possible, and we shall have the obligation to erase personal data without undue delay where
        required by the law, including when:
      </p>
      <ul>
        <li>
          - the personal data is no longer necessary in relation to the purposes for which they were
          collected or otherwise processed;
        </li>
        <li>- there is no longer a legal ground for the processing;</li>
        <li>
          - you object to the processing and there are no overriding legitimate grounds for the
          processing;
        </li>
        <li>- the personal data has been unlawfully processed;</li>
        <li>
          - the personal data must be erased for compliance with a legal obligation in accordance
          with the applicable law to which we are subject.
        </li>
      </ul>
      <h3>Right to restriction of processing</h3>
      <p>
        You have the right to obtain from us the restriction of processing where one of the
        following applies:
      </p>
      <ul>
        <li>
          - the accuracy of the personal data is contested by you, for a period enabling us to
          verify the accuracy of the personal data;
        </li>
        <li>
          - the processing is unlawful and you oppose the erasure of the personal data and requests
          instead the restriction of their use instead;
        </li>
        <li>
          - we no longer needs the personal data for the purposes of the processing, but they are
          required by you for the establishment, exercise or defense of legal claims; and/or
        </li>
        <li>- the personal data has been unlawfully processed;</li>
        <li>- you have objected to processing pursuant to applicable laws.</li>
      </ul>
      <h3>Right to object</h3>
      <p>
        You have the right to object, on grounds relating to your particular situation, at any time,
        to the processing of personal data concerning you. We shall no longer process the personal
        data in the event of the objection, unless we can demonstrate reasonable grounds for the
        processing, which override the interests, rights and freedoms of you, or for the
        establishment, exercise or defense of legal claims.
      </p>
      <h3>Right to withdraw data protection consent</h3>
      <p>
        You have the right to withdraw your consent to the processing of your personal data at any
        time. We, in turn, reserve the right to terminate your access to the Site at any time and
        for any reason.
      </p>
      <h3>International transfers</h3>
      <p>
        We are entitled to transfer your personal data to third parties abroad for the purposes of
        the data processing and external access by you of services provided by those third parties.
        As personal data processors, they are obliged to protect data privacy to the same extent as
        we ourselves. We choose the processors carefully to ensure compliance with applicable laws.
      </p>
      <h3>Data security</h3>
      <p>
        We use appropriate technical and organizational security measures to protect your personal
        data. Our security measures are continuously improved in line with technical developments.
      </p>
      <p>
        Please note that any data transmission on the Internet (e.g. communication by email) is
        generally not secure and we accept no liability for data transmitted to us via the Internet.
        Unfortunately, absolute protection is not technically possible. This information does not
        apply to the websites of third parties and the corresponding links given on the Site. We
        assume no responsibility and liability for these.
      </p>
      <h3>Amendments to this Policy</h3>
      <p>
        We may amend this Privacy Policy at any time by posting the amended version on the Site
        including the effective date of the amended version. The current version of the Privacy
        Policy, as published on the Site, is applicable.
      </p>
      <h3>Conflict or Inconsistency</h3>
      <p>
        In the event of any conflict or inconsistency between this Privacy Policy and any
        non-English language translation thereof, the terms and provisions of this Privacy Policy
        shall control.
      </p>
      <h3>Contact</h3>
      <p>
        Please contact us with questions, comments, or concerns regarding our Privacy Policy as well
        as with any requests at legal@gyro.finance.
      </p>
    </>
  );
};
